import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('commissions', {
    components: {
        datePicker
    },

    data () {
        return {
            tpOptions: {
                format: 'MM-YYYY',
            },

            filters: {
                month: moment().startOf('month').format("MM-YYYY"),
                include_customer_paid: 1,
                include_admin_paid: 1
            },

            loading: false,

            commissions: []
        };
    },

    mounted () {
        this.getCommissions();
    },

    methods: {
        getCommissions () {
            this.loading = true;

            axios.get('/api/commissions-dashboard/', {
                params: {
                    ...this.filters
                }
            }).then(response => {
                this.loading = false;

                this.commissions = response.data;
            });
        },

        toggleCheck (type, id, force) {
            force === undefined ? null : force;

            axios.post('/api/commissions-dashboard/toggle', {
                month: this.filters.month,
                type,
                id,
                force
            }).then(() => {
                this.getCommissions();
            });
        },

        toggleCheckAll (type, sales) {
            let checked = sales.filter(sale => {
                return sale[type] === 1;
            });

            const allChecked = checked.length === sales.length && sales.length > 0 ? false : true;

            let ids = [];

            for (let sale of sales) {
                ids.push(sale.id);
            }

            this.toggleCheck(type, ids, allChecked);
        },

        totalSales (sales) {
            if (sales.length === 0) {
                return 0;
            }

            let total = 0;
            sales.map(sale => {
                total += Number(sale.total);
            });

            return total.toFixed(2);
        },

        totalCommission (type, sales) {
            if (sales.length === 0) {
                return 0;
            }

            let total = 0;

            sales.map(sale => {
                total += Number(sale[type]);
            });

            return total.toFixed(2);
        }
    },

    filters: {
        date (value) {
            return moment(value).format("DD/MM/YYYY");
        }
    }
});